$(window).on('load', function() {
  
  // $(".product-single__description p").addClass("moretext");
  // $(".product-single__description ul").addClass("moretext");
  // $(".product-single__description").append('<a class="moreless-button" href="javascript:void(0)">Read more</a>');
  // $(".product-single__description p:nth-child(1)").removeClass("moretext");
  // $('.moreless-button').click(function() {
  //     $(this).parent().find('.moretext').slideDown();
  //   $(this).remove();
  // });

});

$(document).ready(function(){
  setInterval(function() { 
    var header_top_text = jQuery("#fsb_bar").text();
    if(header_top_text) {
      $(".kg-cart-drawer-shipping").css("display", "flex");
      var kg_cart_drawer = jQuery(".kg-cart-drawer-shipping").text(header_top_text);
    } else {
      $(".kg-cart-drawer-shipping").css("display", "none");
    }
    
  }, 1500);
});


jQuery(document).ready(function ($) {
  var $desc = $('.kg-product-single__description');
  var fullHeight = $desc.outerHeight();
  console.log(fullHeight);

  // Apply collapsed view only if content is taller than 300px
  if (fullHeight > 300) {

    $desc.addClass('collapsed');

    // Add Read More button
    $desc.after('<a class="read-more-btn">Read More</a>');
    $('.read-more-btn').on('click', function () {
      if ($desc.hasClass('collapsed')) {
        $desc.removeClass('collapsed').css('max-height', fullHeight + 'px');
        $(this).text('Close');
      } else {
        $desc.addClass('collapsed').css('max-height', '300px');
        $(this).text('Read More');
        
        // Optional: scroll back to description top
        $('html, body').animate({
          scrollTop: $desc.offset().top - 100
        }, 400);
      }


    });
  }
});

// readmore js start

let slideUp = (target, duration = 500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

let slideDown = (target, duration = 500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
        display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

let slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
}

let $readMoreText = document.querySelector('.readmore-text');
if ($readMoreText) {
  $readMoreText.style.display = 'none';
  $readMoreText.insertAdjacentHTML('afterend', '<a class="readMore" style="cursor:pointer;margin-bottom:12px;display:inline-block;">Read More</a>');
  document.querySelector('.readMore').addEventListener('click', e => {
      e.preventDefault();
      slideToggle(document.querySelector('.readmore-text'));
      document.querySelector('.readMore').innerHTML = (document.querySelector('.readMore').innerHTML == 'Read More') ? 'Close' : 'Read More';
  });
}

// readmore js end
